// language=GraphQL
export const ALL_CONTACT_BANNER_BLOCKS_QUERY = `query Query($withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {
  contactBannerBlocks: cmsContactBannerBlocks {
    id
    employee @include(if: $withEmployee) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeeImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    email
    phonePrefix
    phone
    phone2Prefix
    phone2
  }
}`

// language=GraphQL
export const SINGLE_CONTACT_BANNER_BLOCK_QUERY = `query Query($id: ID!, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {
  contactBannerBlock: cmsContactBannerBlock(id: $id) {
    id
    employee @include(if: $withEmployee) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeeImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    email
    phonePrefix
    phone
    phone2Prefix
    phone2
  }
}`

// language=GraphQL
export const CREATE_CONTACT_BANNER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsContactBannerBlockInput, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {
    contactBannerBlock: createCmsContactBannerBlock(input: $input) {
      id
      employee @include(if: $withEmployee) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeeImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      email
      phonePrefix
      phone
      phone2Prefix
      phone2
    }
  }`

// language=GraphQL
export const UPDATE_CONTACT_BANNER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsContactBannerBlockInput, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {
    contactBannerBlock: updateCmsContactBannerBlock(input: $input) {
      id
      employee @include(if: $withEmployee) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeeImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      email
      phonePrefix
      phone
      phone2Prefix
      phone2
    }
  }`

// language=GraphQL
export const DELETE_CONTACT_BANNER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsContactBannerBlockInput) {
    deleteCmsContactBannerBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsContactBannerBlockInput) {
    forceDeleteCmsContactBannerBlock(input: $input) {
      success
    }
  }`
